export default __webpack_public_path__ + "static/InclusionaryZoning-69660c1d1172e3c700d09227a0bad7e4.jpg";